var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchico = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38559 15.4776C12.4645 15.4776 15.7712 12.2367 15.7712 8.23881C15.7712 4.24092 12.4645 1 8.38559 1C4.30664 1 1 4.24092 1 8.23881C1 12.2367 4.30664 15.4776 8.38559 15.4776Z",
    stroke: "url(#paint0_linear_1_321)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.232 17.8909L14.5392 14.2715",
    stroke: "url(#paint1_linear_1_321)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_321",
    x1: 8.38559,
    y1: 1,
    x2: 8.38559,
    y2: 15.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD06C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C305C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_321",
    x1: 16.3856,
    y1: 14.2715,
    x2: 16.3856,
    y2: 17.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD06C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C305C7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchico);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchico.fee5fd42a588571755e882b0d00fb8a7.svg";